import { cva } from 'class-variance-authority';

export const cvaRoot = cva(['DropzoneFilesStyles-cvaRoot', '']);

export const cvaSelectedFiles = cva(['DropzoneFilesStyles cvaSelectedFiles', 'relative', 'mb-1.6']);

export const cvaSelectedFilesSlider = cva(['DropzoneFilesStyles-cvaSelectedFilesSlider', 'w-full', 'p-0.8 -m-0.8']);

export const cvaSelectedFilesSlide = cva([
  'DropzoneFilesStyles-cvaSelectedFilesSlide',
  'relative',
  '!w-9.8 !h-9.8',
  'select-none',
]);

export const cvaSelectedFilesSlideImageWrap = cva([
  'DropzoneFilesStyles-cvaSelectedFilesSlideImageWrap',
  'relative overflow-hidden',
  'w-full h-full',
  'bg-cMediumGreyOnWhite',
  'rounded-[1.6rem]',
]);

export const cvaSelectedFilesSlideImage = cva([
  'DropzoneFilesStyles-cvaSelectedFilesSlideImage',
  'object-cover object-center',
]);

export const cvaSelectedFilesButton = cva(
  [
    'DropzoneFilesStyles-cvaSelectedFilesButton',
    'flex items-center justify-center',
    'absolute top-1/2 z-[2]',
    '-mt-2.4',
    'w-4.8 h-4.8',
    'bg-cMediumGreyOnWhite',
    'rounded-[1.6rem]',
    '[&.swiper-button-disabled]:hidden',
  ],
  {
    variants: {
      direction: {
        prev: ['-left-2.4'],
        next: ['-right-2.4'],
      },
    },
  }
);

export const cvaSelectedFilesButtonIcon = cva(
  ['DropzoneFilesStyles-cvaSelectedFilesButtonIcon', 'w-1.6 h-1.6', 'stroke-cBlack'],
  {
    variants: {
      direction: {
        prev: ['-rotate-180'],
        next: [''],
      },
    },
  }
);

export const cvaDelete = cva([
  'DropzoneFilesStyles-cvaDelete',
  'absolute -top-0.8 -right-0.8',
  'flex items-center justify-center',
  'w-2.4 h-2.4',
  'bg-cBlack',
  'rounded-full border border-0.1 border-cWhite',
  'cursor-pointer select-none',
]);

export const cvaDeleteIcon = cva(['DropzoneFilesStyles-cvaDeleteIcon', 'w-1.6 h-1.6', '[&_path]:stroke-cWhite']);

export const cvaDrag = cva(['DropzoneFilesStyles-cvaDrag', 'flex items-center gap-2.4', 'cursor-pointer']);

export const cvaInput = cva(['DropzoneFilesStyles-cvaInput', 'hidden']);

export const cvaDragIconWrap = cva([
  'DropzoneFilesStyles-cvaDragIconWrap',
  'flex items-center justify-center',
  'w-9.8 h-9.8 min-w-[9.8rem]',
  'bg-cMediumGreyOnWhite',
  'rounded-[1.6rem]',
]);

export const cvaDragIcon = cva(['DropzoneFilesStyles-cvaDragIcon', 'w-3.2 h-3.2']);

export const cvaDragPlaceholder = cva(['DropzoneFilesStyles-cvaDragPlaceholder', 'text-bodyM text-cBlack64']);
